<div>
  <button
    *ngIf="
      currentPanelMember.member.username === currentUser.username ||
      canModifyDiscussion
    "
    class="btn btn-primary btn-icon"
    (click)="deletePanelSeatModal.show()"
  >
    <i class="icofont icofont-trash" style="margin: auto"></i>
  </button>

  <!-- Delete-panel-seat-modal -->
  <del-panelSeat-auth-modal
    #deletePanelSeatModal
    [currentUser]="currentUser"
    [discussion]="discussion"
    [currentPanelMember]="currentPanelMember"
    [canModifyDiscussion]="canModifyDiscussion"
  >
  </del-panelSeat-auth-modal>
  <!-- Delete-panel-seat-modal -->
</div>
